import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  inject
} from '@angular/core';
import { IMAGE_NOT_AVAILABLE } from '../../core/constants/app.constants';

@Directive({
  selector: 'img[appImgFallback]',
  standalone: true
})
export class ImgFallbackDirective implements OnChanges {
  private readonly el = inject(ElementRef<HTMLImageElement>);
  private failed = false;

  /** Optional custom fallback; defaults to IMAGE_NOT_AVAILABLE. */
  @Input('appImgFallback') fallbackSrc: string | '' = '';

  ngOnChanges(_changes: SimpleChanges): void {
    this.failed = false;
    const src = this.el.nativeElement.getAttribute('src');
    if (!src?.trim()) {
      this.applyFallback();
    }
  }

  @HostListener('error')
  onError(): void {
    this.applyFallback();
  }

  private applyFallback(): void {
    if (this.failed) {
      return;
    }
    this.failed = true;
    this.el.nativeElement.src = this.fallbackSrc || IMAGE_NOT_AVAILABLE;
  }
}
